import { Splide } from '@splidejs/splide';

const SLIDER_CLASS = '.js-slider';
const SLIDE_CLASS = '.js-slide';
const SLIDE_IMAGE_CLASS = '.js-slide-image';
const SLIDER_COUNTER_CLASS = '.js-slider-counter';
const SLIDER_COUNTER_CURRENT_CLASS = '.js-slider-counterCurrent';
const SLIDER_COUNTER_LENGTH_CLASS = '.js-slider-counterLength';

const DEFAULT_OPTION = {
  type: 'loop',
  drag: true,
  perMove: 1,
  // autoWidth: true,
  pagination: false,
  arrows: true,
  flickPower: 300
};

// aria-labelの日本語化
const LABEL_JP = {
  i18n: {
    prev: '前のスライドに移動する',
    next: '次のスライドに移動する',
    first: '最初のスライドに移動する',
    last: '最後のスライドに移動する',
    slideX: '%sページ目のスライドに移動する',
    pageX: '%sページ目に移動する',
    play: '再生',
    pause: '停止',
    select: '表示するスライドを選択する',
    slideLabel: '%sページ目（全%sページ）'
  }
};

export class Slider {
  constructor(el) {
    this.DOM = {};
    this.DOM.el = el;

    if (!this.DOM.el) return;

    this.onInit();
  }
  /**
   * 初期化
   */
  onInit() {
    this.sliderType = this.DOM.el.dataset.sliderType;
    // optionを設定
    this.onInitOption();
    // DOMを取得
    this.onInitDOM();
    // イベントの設定
    this.onInitEvent();
    // スライダーの初期化
    this.onInitSlider();
    // カウンターがある場合の初期化
    if (this.DOM.counter) {
      this.onInitCounter();
    }
  }
  /**
   * オプションの初期化
   */
  onInitOption() {
    this.isJP = document.querySelector('[lang="ja"]');
    this.optionIsJP = this.isJP ? LABEL_JP : {};
    this.option = Object.assign(
      {},
      DEFAULT_OPTION,
      this.optionIsJP,
    );
  }
  /**
   * 取得したいDOMの初期化
   */
  onInitDOM() {
    this.DOM.slides = this.DOM.el.querySelectorAll(SLIDE_CLASS);
    this.DOM.images = this.DOM.el.querySelectorAll(SLIDE_IMAGE_CLASS);
    this.DOM.counter = this.DOM.el.querySelector(SLIDER_COUNTER_CLASS);
    this.DOM.counterCurrent = this.DOM.el.querySelector(
      SLIDER_COUNTER_CURRENT_CLASS
    );
    this.DOM.counterLength = this.DOM.el.querySelector(
      SLIDER_COUNTER_LENGTH_CLASS
    );
  }
  onInitEvent() {
    this.onClickSlider = () => this._onClickSlider();
    this.DOM.el.addEventListener('click', this.onClickSlider);
  }
  _onClickSlider() {
    this.DOM.el.classList.add('is-touched');
    this.DOM.el.removeEventListener('click', this.onClickSlider);
  }
  /**
   * スライダーの初期化
   */
  onInitSlider() {
    this.slider = new Splide(this.DOM.el, this.option);
    this.slider.mount();
  }
  /**
   * カウンターパーツがある場合の初期化
   */
  onInitCounter() {
    this.DOM.counterCurrent.textContent = this.slider.index + 1;
    this.DOM.counterLength.textContent = this.slider.length;
    this.DOM.counter.ariaLabel = this.isJP
      ? `${this.slider.index + 1}ページ目（全${this.slider.length}ページ）`
      : `'${this.slider.index + 1} of ${this.slider.length}`;
    this.slider.on('move', () => {
      this.DOM.counterCurrent.textContent = this.slider.index + 1;
      this.DOM.counterLength.textContent = this.slider.length;
      this.DOM.counter.ariaLabel = this.isJP
        ? `${this.slider.index + 1}ページ目（全${this.slider.length}ページ）`
        : `'${this.slider.index + 1} of ${this.slider.length}`;
    });
  }
  goSlide(i) {
    this.slider.go(i);
  }
}

export class Sliders {
  constructor() {
    this.DOM = {};
    this.DOM.sliders = document.querySelectorAll(SLIDER_CLASS);

    if (!this.DOM.sliders.length) return;

    this.onInit();
  }
  onInit() {
    this.sliders = [];
    this.DOM.sliders.forEach((slider) => {
      this.sliders.push(new Slider(slider));
    });

    this.sliders.forEach((slider) => {
      if (slider.optionIsSyncMain) {
        const $children = slider.DOM.el.querySelector(
          '[data-slider-sync-children]'
        );
        const childrenSlider = new Slider($children);
        slider.slider.sync(childrenSlider.slider);
      }
    });
  }
}
